import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAllRecentRenewalData,
  fetchAllRenewalStatsData,
  fetchAllRenewalTableData,
} from "../../../redux/reducers/apiSlice";
import AllRenewalsTab from "../renewals/AllRenewalsTab";
import ScrollableGrid from "../../common-components/CustomDraggable";
import CarouselReact from "../../components-react/CarouselReact";
import RenewalCard from "./RenewalCard";
import PaginationModified from "../../../data/PaginationModified";
import { selectAuth } from "../../auth/auth.selector";

const Renewals = ({ selectedGyms, daysFilter }) => {
  const dispatch = useDispatch();
  const userInfo = useSelector(selectAuth);
  const [decryptedText, setDecryptedText] = useState(userInfo?.user || {});
  const tableRef = useRef(null);
  const isAdmin = decryptedText?.account_type === "admin";
  const isClusterManager = decryptedText?.account_type === "cluster_manager";
  const [selectedFilter, setSelectedFilter] = useState({});
  const { renewalsStatsData, renewalTableData, recentRenewalData } =
    useSelector((state) => state.api);
  const [searchString, setSearchString] = useState("");
  const [allRenewalsData, setAllRenewalsData] = useState([]);
  const [allRenewalTableData, setAllRenewalTableData] = useState([]);
  const [allRenewalTbPagination, setAllRenewalTbPagination] = useState([]);
  const [isPage, setIsPage] = useState(0);
  const [selectedCard, setSelectedCard] = useState("");
  const [selectedTrainer, setSelectedTrainer] = useState("");

  const [allRecentRenewalData, setAllRecentRenewalData] = useState([]);
  const [gymActiveMembersData, setGymActiveMembersData] = useState([]);
  const [allGymActiveMembers, setAllGymActiveMembers] = useState(null);

  const [searchQueryParam, setSearchQueryParam] = useState("");

  const selectedGymQueryParam =
    isAdmin && selectedFilter?.value
      ? `&gym_id=${selectedFilter.value}`
      : isAdmin && selectedGyms?.value
      ? `&gym_id=${selectedGyms.value}`
      : !isAdmin && !isClusterManager
      ? `&gym_id=${
          decryptedText?.gym_id || decryptedText?.uid || decryptedText?.user_id
        }`
      : "";
  const selectedGymQueryParamStat =
    isAdmin && selectedGyms?.value
      ? `&gym_id=${selectedGyms.value}`
      : !isAdmin && !isClusterManager
      ? `&gym_id=${
          decryptedText?.gym_id || decryptedText?.uid || decryptedText?.user_id
        }`
      : "";
  const trainerIdQueryParam = selectedTrainer
    ? `&user_id=${selectedTrainer}`
    : "";
  // const searchQueryParam = searchString ? `&search=${searchString}` : "";

  const startDateQueryParam =
    daysFilter?.startDate && daysFilter?.endDate
      ? `&start_date=${daysFilter.startDate}&end_date=${daysFilter.endDate}`
      : daysFilter?.startDate
      ? `&start_date=${daysFilter.startDate}`
      : daysFilter?.endDate
      ? `&end_date=${daysFilter.endDate}`
      : "";
  let queryParametersFor = `${selectedGymQueryParam}${startDateQueryParam}${trainerIdQueryParam}`;
  let queryParametersForStat = `${selectedGymQueryParamStat}${startDateQueryParam}`;
  let queryParametersForRR = `${selectedGymQueryParam}${startDateQueryParam}`;

  const onClickSearch = () => {
    setSearchQueryParam(searchString ? `&search=${searchString}` : "");
    setIsPage(0);
    // dispatch(
    //   fetchAllRenewalTableData({
    //     pageNo: 1,
    //     queryParameters: queryParametersFor,
    //     searchString: searchQueryParam,
    //     token: decryptedText?.token,
    //   })
    // );
  };

  let activeMembers = {};
  gymActiveMembersData.forEach((gymData) => {
    let gymId = Object.keys(gymData)[0];
    activeMembers[gymId] = gymData[gymId].active_member;
  });

  function getPagination() {
    try {
      const pagination = allRenewalTbPagination ? allRenewalTbPagination : [];
      return pagination;
    } catch (error) {
      console.log(error);
    }
  }

  const handleCardClick = () => {
    if (selectedFilter?.label === selectedGyms?.label) {
      setSelectedFilter(null);
    } else {
      setSelectedFilter(selectedGyms);
      tableRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    dispatch(
      fetchAllRenewalStatsData({
        queryParameters: queryParametersForStat,
        token: decryptedText?.token,
      })
    );
  }, [queryParametersForStat]);

  useEffect(() => {
    dispatch(
      fetchAllRenewalTableData({
        pageNo: isPage + 1,
        queryParameters: queryParametersFor + searchQueryParam,
        token: decryptedText?.token,
      })
    );
  }, [queryParametersFor, isPage, searchQueryParam]);

  useEffect(() => {
    dispatch(
      fetchAllRecentRenewalData({
        queryParameters: queryParametersForRR,
        token: decryptedText?.token,
      })
    );
  }, [queryParametersForRR]);

  useEffect(() => {
    if (renewalsStatsData?.status && renewalsStatsData?.data) {
      setAllRenewalsData(renewalsStatsData.data);
    }

    if (renewalsStatsData?.status && renewalsStatsData?.gym_active_member) {
      setGymActiveMembersData(renewalsStatsData.gym_active_member);
      setAllGymActiveMembers(renewalsStatsData?.all_gym_active_member);
    }
  }, [renewalsStatsData]);

  useEffect(() => {
    if (renewalTableData?.status) {
      setAllRenewalTableData(renewalTableData);
      setAllRenewalTbPagination(renewalTableData?.pagination);
    }
  }, [renewalTableData, isPage]);

  useEffect(() => {
    if (recentRenewalData?.status) {
      setAllRecentRenewalData(recentRenewalData?.data);
    }
  }, [recentRenewalData]);

  useEffect(() => {
    if (searchString?.length === 0) {
      setSearchQueryParam("");
      // dispatch(
      //   fetchAllRenewalTableData({
      //     pageNo: 1,
      //     queryParameters: queryParametersFor,
      //     token: decryptedText?.token,
      //   })
      // );
    }
  }, [searchString]);

  useEffect(() => {
    if (!selectedGyms) {
      setSelectedFilter(null);
    }
  }, [selectedGyms]);

  useEffect(() => {
    if (userInfo?.isAuthenticated && userInfo?.user) {
      setDecryptedText(userInfo.user);
    }
  }, [userInfo]);

  return (
    <div className="columsDivsContainer">
      {isAdmin ? (
        <>
          {selectedGyms?.value && (
            <div className="flexWrapStartCenterContainer">
              <RenewalCard
                onClick={handleCardClick}
                active={selectedFilter?.label === selectedGyms?.label}
              >
                <div className="flex-k items-start-k p-3 flex-col-k gap-3 p-2-k">
                  <span>{selectedGyms?.label}</span>
                  <span className="rounded-3 p-2 border-k">
                    <span className="bold-text fs-3">
                      {activeMembers[selectedGyms.value] || 0}
                    </span>{" "}
                    Members
                  </span>
                </div>
              </RenewalCard>
            </div>
          )}
        </>
      ) : (
        <div className="horizontallyScrollCardsContainer">
          <div className="cussss renewlaCustomDraggable">
            <ScrollableGrid
              tabName={"renewals"}
              statsData={allRenewalsData || []}
              selectedCard={selectedCard}
              setSelectedCard={setSelectedCard}
              setSelectedTrainer={setSelectedTrainer}
              tableRef={tableRef}
            />
          </div>
        </div>
      )}

      <div className="allPtMembersContainer allRenewlasTabBtnTableContainer">
        <div className="headingAndButtonsContainer">
          <h2 className="header">All Membership Expiring Within 30 Days</h2>
        </div>

        <div
          className="ptMembersTabAndButtons gap0"
          ref={tableRef}
          style={{ flexDirection: "column" }}
        >
          <AllRenewalsTab
            allRenewalTableData={allRenewalTableData}
            searchString={searchString}
            setSearchString={setSearchString}
            onClickSearch={onClickSearch}
          />

          <div className="fullWidthFlexCenter">
            <div className="customTablePaginationContainer">
              <PaginationModified
                isPage={isPage}
                onChangePage={setIsPage}
                pagination={getPagination()}
              />
            </div>
          </div>
        </div>
      </div>

      {allRecentRenewalData?.length > 0 && (
        <div className="horizontallyScrollCardsContainer recentReneals">
          <h2 className="header">Recent renewals</h2>
          <CarouselReact allData={allRecentRenewalData} />
        </div>
      )}
    </div>
  );
};

export default Renewals;
